<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Resumen</label
                >
                <div class="col-md-9">
                    <textarea
                        name="summary"
                        v-model="summary"
                        style="display: none"
                    ></textarea>
                    <ckeditor
                        :editor="editor"
                        v-model="summary"
                        :config="editorConfig"
                    ></ckeditor>
                    <span v-if="allerrors.summary" :class="['show-error']">{{
                        allerrors.summary[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Agregar
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
    props: {
        model_id: Number,
        parent_id: Number,
    },
    data() {
        return {
            action: "",
            summary: null,
            allerrors: {
                summary: null,
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "bold",
                    "italic",
                    "underline",
                    "bulletedList",
                    "numberedList",
                ],
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/contests/requirements/show/" + me.model_id)
                .then(function (response) {
                    me.summary = response.data.model.summary;
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;
            if (me.validForm()) {
                axios
                    .post(me.action, {
                        summary: me.summary,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(me.action, {
                        summary: me.summary,
                        contest_id: me.parent_id,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Actualizacion exitosa!");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;
            if (!me.summary) {
                me.allerrors.summary = ["El campo resumen es obligatorio."];
                valid = false;
            } else if (me.summary.length > 278) {
                me.allerrors.summary = [
                    "El campo resumen debe tener máximo 278 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.summary = [""];
            }
            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                summary: null,
            };
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
    },
    mounted() {
        let me = this;
        const authUserId = document.querySelector(
            'meta[name="x-user"]'
        ).content;
        if (me.model_id == 0) {
            me.action = `/api/contests/requirements?contest_id=${me.parent_id}&key=${authUserId}`;
        } else {
            this.getModel();
            me.action = "/api/contests/requirements/update/" + me.model_id;
        }
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
